import { useMemo, useState } from 'react'
import type { PrescriberJoinedLocationProfile } from '../../../types/location'

function filterProfilesByLocationName(
  profiles: PrescriberJoinedLocationProfile[],
  searchQuery: string
): PrescriberJoinedLocationProfile[] {
  const q = searchQuery.trim().toLowerCase()
  if (!q) return profiles
  return profiles.filter((p) => p.location.name.toLowerCase().includes(q))
}

export function usePrescriberLocationProfileSearch(profiles: PrescriberJoinedLocationProfile[]) {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredProfiles = useMemo(
    () => filterProfilesByLocationName(profiles, searchQuery),
    [profiles, searchQuery]
  )

  return { searchQuery, setSearchQuery, filteredProfiles }
}
